import { BRAND_SECONDARY } from "../../../utils/Styles";
import React from "react";
import {
  Stack,
  PrimaryButton,
  Callout,
  DirectionalHint,
  Fabric,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  IColumn,
  DefaultButton,
  FocusTrapZone,
  Calendar,
  DayOfWeek,
} from "office-ui-fabric-react";
import {
  ITempAndRhPageWiseRemarks,
} from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { childrenGap, DayPickerStrings } from "../../common/Constants";
import Icon from "@mdi/react";
import {
  mdiDotsVertical,
} from "@mdi/js";
import { Loading } from "../../../services/Loading";
import NoDataTile from "../../common/NoDataTile";
import {
  parseJwt,
} from "../../../services/UtilService";
import { deleteTempAndRhRemarks, getTempAndRhRemarks } from "../../../services/customers/CustomerService";
import ManageTempRhRemarksDialog from "./ManageTempRhRemarksDialog";
import moment from "moment";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";

let calendarButtonElement: HTMLElement;

export interface TempRhRemarksProps {
  customerId: string;
  date: Date | string;
  tempRhPageId: string;
  datacenterId: string;
}

const TempRhRemarks: React.FC<TempRhRemarksProps> = ({ customerId, date, tempRhPageId, datacenterId }) => {
  //custom hooks
  const { showToast } = React.useContext(ToastContext);
  const tokenData = parseJwt();
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    searchObj: {
      tempRhPageId: tempRhPageId,
      date: moment(date).toDate()
    },
    tempRhRemarks: [],
    manageRemarksDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    date: moment(date).toDate(),
    showCallender: false,
  } as {
    isLoading: boolean;
    searchObj: {
      tempRhPageId: string,
      date: Date | string
    };
    tempRhRemarks: ITempAndRhPageWiseRemarks[];
    manageRemarksDialog: {
      isOpen: boolean;
      index?: number;
      data?: ITempAndRhPageWiseRemarks;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: ITempAndRhPageWiseRemarks;
    };
    date: Date;
    showCallender: boolean;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getTempRhRemarksList();
    };
    asyncFunc();
  }, []);


  const getTempRhRemarksList = async () => {
    let localState = { ...state };

    setState({ ...localState, isLoading: true });
    localState.searchObj.date = moment(localState.searchObj.date).format("YYYY-MM-DD");
    let result = await getTempAndRhRemarks(localState.searchObj);
    if (result?.success) {
      setState({ ...localState, tempRhRemarks: result.data, isLoading: false })
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting temp rh remarks",
        "error"
      );
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let tempRhRemarks = undefined;
    if (index !== undefined) {
      tempRhRemarks = { ...state.tempRhRemarks[index] };
    }
    setState({
      ...state,
      manageRemarksDialog: {
        isOpen: isOpen,
        index: index,
        data: tempRhRemarks,
      },
    });
  };

  const handleDialogClose = (data?: ITempAndRhPageWiseRemarks) => {
    let tempRhRemarks = [...state.tempRhRemarks];
    if (data) {
      if (state.manageRemarksDialog.index !== undefined) {
        tempRhRemarks[state.manageRemarksDialog.index] = data;
        showToast("Temp/Rh Remarks updated successfully", "success");
      } else {
        tempRhRemarks.unshift(data);
        showToast("Temp/Rh Remarks added successfully", "success");
      }
    }
    setState({
      ...state,
      manageRemarksDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      tempRhRemarks: tempRhRemarks,
    });
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: ITempAndRhPageWiseRemarks
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const deleteTempRhRemarks = async (item: ITempAndRhPageWiseRemarks, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete temp/rh remarks",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteTempAndRhRemarks(item);
        if (result?.success) {
          showToast("Temp/Rh Remarks deleted successfully", "success");
          let tempRhRemarks = [...state.tempRhRemarks];
          tempRhRemarks.splice(index, 1);
          setState({
            ...state,
            tempRhRemarks: tempRhRemarks,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting Temp/Rh Remarks",
            "error"
          );
        }
      }
    );
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const onSearch = async () => {
    getTempRhRemarksList();
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Stack tokens={childrenGap} horizontal horizontalAlign="start">
            <Stack.Item>
              <div
                ref={(calendarBtn) =>
                  (calendarButtonElement = calendarBtn!)
                }
              >
                <DefaultButton
                  text={
                    !state.date
                      ? "Select a month"
                      : moment(state.date).format("MMM-YYYY")
                  }
                  onClick={() =>
                    setState({ ...state, showCallender: true })
                  }
                  className="month-picker-btn"
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  // className="ms-DatePicker-callout"
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus
                >
                  <FocusTrapZone
                    firstFocusableSelector="ms-DatePicker-day--today"
                    isClickableOutsideFocusTrap
                  >
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) =>
                        setState({
                          ...state,
                          date: date as any,
                          searchObj: {
                            ...state.searchObj,
                            date: date as any
                          },
                          showCallender: false,
                        })
                      }
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={state.date}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                      maxDate={moment().toDate()}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton text="Search" onClick={() => onSearch()} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            horizontalAlign="end"
            wrap
            tokens={childrenGap}
          >
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton
                  text="Add Remarks"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                  disabled={state.tempRhRemarks.length > 0}
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.tempRhRemarks && state.tempRhRemarks.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.tempRhRemarks}
                columns={
                  ![2, 4, 5].includes(tokenData.role)
                    ? [
                      {
                        key: "remarks",
                        name: "Remarks",
                        fieldName: "remarks",
                        minWidth: 250,
                        maxWidth: 450,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 80,
                        maxWidth: 130,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "remarks",
                        name: "Remarks",
                        fieldName: "remarks",
                        minWidth: 250,
                        maxWidth: 450,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Temp/Rh Remarks Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
        {state.manageActionsCallout.isOpen && (
          <Callout
            styles={{ root: { width: 95, padding: 20 } }}
            role="alertdialog"
            ariaLabelledBy={
              state.manageActionsCallout && state.manageActionsCallout.data?._id
            }
            gapSpace={0}
            target={state.manageActionsCallout.element}
            directionalHint={DirectionalHint.leftCenter}
            onDismiss={() => handleCallOutOpenClose(false)}
          // setInitialFocus={true}
          >
            <Stack tokens={childrenGap}>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handleDialogOpen(true, state.manageActionsCallout.index);
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    deleteTempRhRemarks(
                      state.manageActionsCallout.data as ITempAndRhPageWiseRemarks,
                      state.manageActionsCallout.index as number
                    );
                  }}
                  className="callout-options"
                >
                  Delete
                </span>
              </Stack.Item>
            </Stack>
          </Callout>
        )}
      </Stack>
      {state.manageRemarksDialog.isOpen && (
        <ManageTempRhRemarksDialog
          data={state.manageRemarksDialog.data}
          handleLoading={handleLoading}
          customerId={customerId}
          handleDialogClose={(data?: ITempAndRhPageWiseRemarks) => handleDialogClose(data)}
          date={state.searchObj.date as Date}
          datacenterId={datacenterId}
          tempRhPageId={tempRhPageId}
        />
      )}
    </React.Fragment>
  );
};

export default TempRhRemarks;
